import { Link } from 'react-router-dom';

export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-black overflow-hidden pt-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 w-full">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="space-y-6 sm:space-y-8">
            <div className="inline-block px-4 py-2 bg-white/5 border border-white/10 rounded-full">
              <span className="text-xs sm:text-sm text-gray-300 font-medium">AI-Powered Web Development · Nashville, TN</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold leading-tight text-white">
              Your Business
              <br />
              Deserves a
              <br />
              <span className="text-gray-300 font-light italic">Website</span>
            </h1>

            <p className="text-base sm:text-xl text-gray-400 leading-relaxed max-w-xl">
              We help Nashville small businesses launch fast, modern websites using AI — so customers can find you online in days, not months. Affordable, professional, and built to rank.
            </p>

            <div className="flex flex-wrap gap-3 sm:gap-6 text-sm text-gray-400 pt-2">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-flashlight-line text-white"></i>
                </div>
                <span>Live in Days</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-white"></i>
                </div>
                <span>Nashville Local</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-pencil-ruler-2-line text-white"></i>
                </div>
                <span>100% Custom Built</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-money-dollar-circle-line text-white"></i>
                </div>
                <span>Starting at $1,000</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row flex-wrap gap-4 pt-2">
              <button
                onClick={scrollToContact}
                className="px-8 py-4 bg-white text-black font-semibold rounded-lg hover:bg-gray-200 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-center"
              >
                Get a Free Demo Website
              </button>
              <Link
                to="/portfolio"
                className="px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                View Our Work
              </Link>
            </div>
          </div>

          <div className="relative mt-4 lg:mt-0">
            <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-gray-900 to-black p-4 sm:p-8 shadow-2xl border border-white/10">
              <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent"></div>
              <img
                src="https://public.readdy.ai/ai/img_res/6a6bbbd7e714cb86bc2bccbb51cad5cd.jpg"
                alt="AI-powered web development Nashville TN — Modern Website Design by GWDevelopers"
                loading="eager"
                fetchPriority="high"
                decoding="async"
                className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500 object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-white/5 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
